import { render, staticRenderFns } from "./SpacesSettings.vue?vue&type=template&id=f0730726&"
import script from "./SpacesSettings.vue?vue&type=script&lang=js&"
export * from "./SpacesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports